import React from 'react';
import { withRouter } from 'react-router-dom';
import withContainer from '../../containers/WithContainer';
import loading from '../../Callback/loading.svg';
import WizardCard from '../../components/WizardCard/WizardCard';
import Appear from '../../components/Appear/Appear';

class OnBoarding extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {};
  }
  app = this.props.appContainer;

  componentDidUpdate() {
    let queryString = this.props.location.search;
    this.app.takeToFirstStepIfNeeded(queryString);
    this.app.takeToLastStepIfNeeded(queryString);
  }

  render() {
    return (
      <div>
        {!this.app.isProviderLoaded() && (
          <div style={{ textAlign: 'center' }}>
            {' '}
            <img src={loading} alt="loading" />
          </div>
        )}
        {this.app.isProviderLoaded() && this.app.isProviderFirstTime() && (
          <div style={{ textAlign: 'center' }}>
            {' '}
            <img src={loading} alt="loading" />
          </div>
        )}
        {this.app.isProviderLoaded() && !this.app.isProviderFirstTime() && (
          <WizardCard
            isPrevHidden
            delay={0.2}
            duration={0.2}
            subTitle="Continue where you left off!"
            title={`Welcome back  ${this.app.getProvider().name},`}
            isNextHidden
          >
            <Appear delay={1.5} duration={0.5}>
              <button
                className="button is-primary is-full-width has-margin-top-50"
                onClick={() =>
                  this.props.history.push('/step-1')
                }
              >
                Continue Sign Up
              </button>
            </Appear>
          </WizardCard>
        )}
        {/*   {app.isLoggedIn() &&
          <button onClick={() => { app.logout() }}>Sign Out</button>
        } */}
      </div>
    );
  }
}

export default withRouter(withContainer(OnBoarding));
